
import { isClient, isServer } from '@microrealestate/commonui/utils';

import axios from 'axios';
import config from '../config';
import FileDownload from 'js-file-download';
import { getStoreInstance } from '../store';
import api from './apiService';
import Cookies from 'js-cookie';

let apiFetch;
let authApiFetch;
const withCredentials = config.CORS_ENABLED;

export const getAccessToken = () => {
  const authToken = Cookies.get(config.ACCESS_TOKEN_KEY);

  return authToken ?? ""
}

export const setAccessToken = (accessToken) => {
  Cookies.set(config.ACCESS_TOKEN_KEY, accessToken, { expires: 7, secure: true }); // remove the cookies in 7 days

  // apiFetcher();
  // let token = getAccessToken() ?? accessToken;
  // if (token) {
  //   apiFetch.defaults.headers.common['Authorization'] = `Bearer ${getAccessToken()}`;
  // } else {
  //   delete apiFetch.defaults.headers.common['Authorization'];
  // }
};

export const setOrganizationId = (organizationId) => {
  Cookies.set(config.ORG_KEY, organizationId, { expires: 7, secure: true });

  // apiFetcher();
  // if (organizationId) {
  //   apiFetch.defaults.headers.organizationId = organizationId;
  // } else if (organizationId === null) {
  //   delete apiFetch.defaults.headers.organizationId;
  // }
};

export const getOrgID = () => {
  const store = getStoreInstance();
  const OrgID = Cookies.get(config.ORG_KEY) || store.organization?.selected?._id;
  return OrgID || null;

}
export const setAcceptLanguage = (acceptLanguage) => {
  apiFetcher();
  if (acceptLanguage) {
    apiFetch.defaults.headers['Accept-Language'] = acceptLanguage;
  }
};

export const apiFetcher = () => {
  if (!apiFetch) {
    // create axios instance
    apiFetch = axios.create({
      baseURL: process.env.NEXT_PUBLIC_GATEWAY_URL,
      //  isServer()
      //   ? config.DOCKER_GATEWAY_URL || config.GATEWAY_URL
      //   : config.GATEWAY_URL,
      withCredentials,
    });
    apiFetch.interceptors.request.use(
      (request) => {
        request.headers.Authorization = `Bearer ${getAccessToken()}`;
        const orgId = getOrgID();
        if (orgId) {
          request.headers.Organizationid = orgId;
        }
        return request;
      },
      (error) => Promise.reject(error)
    )
    // manage refresh token on 401
    let isRefreshingToken = false;
    let requestQueue = []; // used when parallel requests
    apiFetch.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;

        const isLoginRequest =
          originalRequest?.url === '/authenticator/signin' &&
          originalRequest?.method === 'post';

        const isImpersonateRequest =
          originalRequest?.url === '/authenticator/impersonate' &&
          originalRequest?.method === 'post';

        const isImpersonateExchangeRequest =
          originalRequest?.url === '/authenticator/impersonate-exchange' &&
          originalRequest?.method === 'post';

        // Try to to refresh token once get 401
        if (
          error.response?.status === 401 &&
          !isLoginRequest &&
          !isImpersonateRequest &&
          !isImpersonateExchangeRequest &&
          !originalRequest._retry
        ) {
          if (isRefreshingToken) {
            // queued incomming request while refresh token is running
            return new Promise(function (resolve, reject) {
              requestQueue.push({ resolve, reject });
            })
              .then(async () => {
                // use latest authorization token
                originalRequest.headers['Authorization'] =
                  apiFetch.defaults.headers.common['Authorization'];

                return apiFetch(originalRequest);
              })
              .catch((err) => Promise.reject(err));
          }

          originalRequest._retry = true;
          isRefreshingToken = true;

          try {
            // try to get store instance
            const store = getStoreInstance();
            // call refresh token
            await store.user.refreshTokens();

            // run all requests queued
            requestQueue.forEach((request) => {
              request.resolve();
            });

            // use latest authorization token
            originalRequest.headers['Authorization'] =
              apiFetch.defaults.headers.common['Authorization'];
            return apiFetch(originalRequest);
          } finally {
            isRefreshingToken = false;
            requestQueue = [];
          }
        }

        return Promise.reject(error);
      }
    );

    // force signin on 403
    // apiFetch.interceptors.response.use(
    //   (response) => response,
    //   (error) => {
    //     // Force signin if an api responded 403
    //     if (error.response?.status === 403) {
    //       if (isClient()) {
    //         window.location.assign(`${config.BASE_PATH}`);
    //       }
    //       throw new Cancel('Operation canceled force login');
    //     }
    //     return Promise.reject(error);
    //   }
    // );

    // For logging purposes

    // apiFetch.interceptors.response.use(
    //   (response) => {
    //     if (
    //       response?.config?.method &&
    //       response?.config?.url &&
    //       response?.status
    //     ) {
    //       console.log(
    //         `${response.config.method.toUpperCase()} ${response.config.url} ${response.status
    //         }`
    //       );
    //     }
    //     return response;
    //   },
    //   (error) => {
    //     if (
    //       error?.config?.method &&
    //       error?.response?.url &&
    //       error?.response?.status
    //     ) {
    //       console.error(
    //         `${error.config.method.toUpperCase()} ${error.config.url} ${error.response.status
    //         }`
    //       );
    //     } else {
    //       console.error(error);
    //     }
    //     return Promise.reject(error);
    //   }
    // );
  }
  return apiFetch;
};

export const authApiFetcher = (cookie) => {
  if (isClient()) {
    return;
  }

  const axiosConfig = {
    baseURL: config.DOCKER_GATEWAY_URL || config.GATEWAY_URL,
    withCredentials,
  };
  if (cookie) {
    axiosConfig.headers = { cookie };
  }
  authApiFetch = axios.create(axiosConfig);
  return authApiFetch;
};

export const buildFetchError = (error) => {
  return {
    error: {
      status: error.response?.status,
      statusText: error.response?.statusText,
      headers: error.response?.headers,
      request: {
        url: error.response?.config?.url,
        method: error.response?.config?.method,
        headers: error.response?.config?.headers,
        baseURL: error.response?.config?.baseURL,
        withCredentials: error.response?.config?.withCredentials,
      },
    },
  };
};

export const downloadDocument = async ({ endpoint, documentName, responseType = 'blob', returnResponse = false }) => {
  try {
    const response = await apiFetcher().get(endpoint, { 
      responseType, 
    });

    if (returnResponse) {
      return { status: response.status, data: response.data };
    }

    FileDownload(response.data, documentName);
    return { status: response.status, data: [] };
  } catch (error) {
    const res = error?.response;
    const status = res?.status ?? 0;
    console.log(error)
    let message = error?.message || 'Unknown error';
    let data = [];

    if (res?.data) {
      try {
        const text = await new Response(res.data).text();
        try {
          const json = JSON.parse(text);
          message = json?.error?.message || json?.message || text;
          data = [json];
        } catch {
          message = text || message;
          data = [{ error: { status, message } }];
        }
      } catch {
        data = [{ error: { status, message } }];
      }
    } else {
      data = [{ error: { status, message } }];
    }

    return { status, message, data };
  }
};

export const getDocument = async ({ key, documentCategory, convertToObjectURL = false}) => {
  const response = await apiFetcher().post(`/documents/using/`, {
    documentCategory,
    key,
  }, {
    responseType: 'blob',
  });
  
  return convertToObjectURL ? URL.createObjectURL(response.data) : response;
}

export const getPresignedUrl = async ({ documentCategory, key }) => {
  try {
    const response = await apiFetcher().post(`/documents/using/`, {
      documentCategory,
      key,
      getSignedUrl: true,
    });
    
    return response.data.signedUrl;
  } catch (error) {
    return null;
  }
};

export const uploadDocument = async ({
  identifier,
  documentCategory,
  file,
  onUploadProgress,
  addWatermark = false,
  scanType,
}) => {
  const formData = new FormData();
  if (documentCategory) {
    formData.append('documentCategory', documentCategory);
  }
  if (identifier) {
    formData.append('identifier', identifier);
  }
  if (scanType) {
    formData.append('scanType', scanType);
  }

  formData.append('addWatermark', addWatermark);
  formData.append('file', file);
  return await apiFetcher().post('/documents/upload', formData, {
    headers: {
      timeout: 30000,
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (event) => {
      if (event.total) {
        const percent = Math.round((event.loaded * 100) / event.total);
        if (typeof onUploadProgress === 'function') {
          onUploadProgress(percent);
        }
      }
    },
  });
};

export const deleteDocument = async ({ identifier, documentCategory }) => {
  return await apiFetcher().delete(`/documents/using/${documentCategory}/${identifier}`);
}

export const uploadDocumentLandingPage = async ({ endpoint, documentName, files, folder }) => {
  const formData = new FormData();
  if (folder) {
    formData.append('folder', folder);
  }
  formData.append('fileName', documentName);

  files.forEach((file) => {
    formData.append('files', file); // The 'files' key matches the backend
  });

  return await apiFetcher().post(endpoint, formData, {
    headers: {
      timeout: 30000,
      'Content-Type': 'multipart/form-data',
    },
  });
};
